<script>

import DropFile from "@/components/fields/DropFile.vue";

const events = ['dragenter', 'dragover', 'dragleave', 'drop']

function preventDefaults(e) {
  e.preventDefault()
}

// eslint-disable-next-line
function uniqueName(obj) {
  return obj.reduce((acc, el) => {
    let temp_indexes = []
    obj.forEach((element, index) => {
      if (element.item.name === el.item.name) {
        temp_indexes.push(index)
      }
    })

    if (temp_indexes.length) {
      const popped = temp_indexes.pop()

      let c = false
      acc.forEach((el) => {
        if (obj[popped].item.name === el.item.name) {
          c = true
        }
      })

      //если нет в списке
      if (!c) {
        acc.push(obj[popped])
      }
    }

    return acc
  }, [])
}


export default {
  name: "DropZone",
  emits: [
      'files-dropped'
  ],
  components: {
    DropFile
  },
  data () {
    return {
      files: [],
      index: 0,
    }
  },
  mounted() {

    events.forEach((eventName) => {
      document.body.addEventListener(eventName, preventDefaults)
    })

  },
  unmounted() {

    events.forEach((eventName) => {
      document.body.removeEventListener(eventName, preventDefaults)
    })

  },

  methods: {

    onDrop(e) {

      // this.files = []
      const files = [...e.dataTransfer.files]
      // let index = 0
      //сделал индекс глобальным
      let index = this.index
      files.forEach((item) => {
        this.files.push({index, item})
        index++
      })

      this.index = index

      const temp = this.files
      this.files = uniqueName(temp)


      // this.$emit('files-dropped', [...e.dataTransfer.files])
      this.$emit('files-dropped', this.files)

    },

    fileFieldChange(event) {

      const files = event.target.files

      let index = this.index

      for( const item of files) {
        this.files.push({index, item})
        index++
      }

      this.index = index

      const temp = this.files
      this.files = uniqueName(temp)


      this.$emit('files-dropped', this.files)

    },

    deleteFile(data) {

      const {index} = data
      const files = this.files

      this.files = files.filter(item => item.index !== index)

      this.$emit('files-dropped', this.files)

    },

  },

}
</script>

<template>

  <div class="input-field">

    <div class="drop" @drop.prevent="onDrop" v-show="!files.length">
      <label for="download_file_test">
        <input id="download_file_test" type="file" multiple="multiple" @change="fileFieldChange">
        <div class="drop-label">Attach Logs (Optional)</div>
        <div class="drop-text"><span>Browse files</span> or drop here</div>
      </label>
    </div>

    <div class="files" v-if="files.length" @drop.prevent="onDrop">
      <div class="files-block">
        <div class="drop-label">Attach Logs (Optional)</div>

        <div v-for="file of files" :key="file.index">
          <DropFile :customData="file" :allowedExtension="['iso', 'pdf', 'zip', 'log', 'txt', 'jpg', 'png', '7z', 'gz', 'tgz']" @delete-file="deleteFile"/>
        </div>

      </div>
    </div>

    <div class="files-set">
      <div class="input-hint">Upload up to 5 files (max 1GB each). Supported formats: .pdf, .zip, .tar.gz, .7z, .log, .txt, .jpeg, .png.</div>
      <label for="download_file_test" class="btn-add-more" v-if="files.length">Add more files</label>
    </div>


  </div>

</template>

<style >
  .drop-zone {
    width: 100%;
    height: 100px;
    background-color: aliceblue;
  }

  .drop {
    position: relative;
  }

  .drop .drop-label,
  .files .drop-label {
    position: absolute;
    top: -7px;
    left: 12px;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #576680;
    background-color: #FFF;
    padding: 0 8px;
    z-index: 0;  
  }


  .drop .drop-text {
    font-family: Raleway;
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
  }

  .files label {
    justify-content: left;
    align-items: flex-start;
  }

  .input-field .drop .drop-text span {
    color: #0A4CB5;
  }

.form-main .input-field .drop label,
.form-main .input-field .files .files-block {
    position: relative;
    top: 0;
    left: 0;
    display: flex;
    border: 1px solid #D6DDEC;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 140px;  
    transition: .2s;
    padding: 24px 20px;
  }

  .form-main .input-field .drop label {
    cursor: pointer;
  }

  .drop input {
    display: none;
  }

  .form-main .input-field .drop label:hover {
    border-color: #9CA5B8;
  }

  .drop label:hover .drop-text span {
    color: #0A3B89;
  }

  .form-main .input-field .files .files-block {
    align-items: flex-start;
    justify-content: left;
    flex-wrap: wrap;
    gap: 12px;
  }

  .files .file-item {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    background-color: #F0F5FF;
    padding: 8px 16px;
    display: flex;
    align-items: center;
  }

  .files .file-item .btn-close {
    margin-left: 14px;
    display: flex;
  }  


  .files .btn-wrap{
    text-align: right;
  }

  .files-set {
    display: flex;
    margin-top: 8px;
  }

  .input-hint {
    padding: 0 20px;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #576680;
  }

  .form-main .input-field .files-set .btn-add-more {
    position: relative;
    top: 0;
    left: 0;
    color: #0a4cb5;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    padding: 8px 16px;
    border: 1px solid #0a4cb5;
    display: inline-block;
    cursor: pointer;
    transition: .2s;
    top: 0;
    bottom: 0;
    margin: auto 0;
    height: 40px;
    background-color: #ffffff;
    white-space: nowrap;
  }

  .form-main .input-field .files-set .btn-add-more:hover {
    color: #0A3B89;
    border-color: #0A3B89;
    box-shadow: inset 0 0 0 .5px #0A3B89;
  }

  @media screen and (max-width: 767px) {
    .files-set {
      flex-direction: column;
      align-items: end;
    }
    .form-main .input-field .files-set .btn-add-more {
      margin-top: 12px;
    }
  }

</style>